<template>
  <div class="homebody">
    <div class="body-article">
      <a href="https://home4love.com/" target="_blank">ONLINE SERVICE</a>
        <div class="body-article-header">
          <article class="content">
            <p class="content-title">专业云端知识库</p>
            <p class="content-desc">面向个人和团队，提供与众不同的知识管理，打造轻松流畅的知识协同。</p>
            <el-button type="success" style="font-weight: bolder" size="mini">登录</el-button>
          </article>
				</div>
				<ul>
					<li>12</li>
					<li>12</li>
					<li>12</li>
					<li>12</li>
				</ul>
    </div>
    <div class="body-section">
      <div class="body-section-wechat"></div>
      <div class="body-section-article"></div>
      <div class="body-section-link"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeBody',
  data() {
    return {
      value:'12312332',
      obj:Object

    }
  }
}
</script>

<style scoped lang="stylus">
.homebody
  margin-top 500px
  background #fafafa
  overflow hidden
  padding 24px 16px
  display flex;
  justify-content center
	.body-article
		height 500px
		width 720px
		display block
		.body-article-header
      width 100%
      height 224px
      background #fff url(https://gw.alipayobjects.com/mdn/prod_resou/afts/img/A*_D1gQrqwtQIAAAAAAAAAAABkARQnAQ) no-repeat
      background-size  55% auto
      background-position bottom right
      cursor pointer
      border 1px solid #e8e8e8
      border-radius 4px
      .content
        margin 40px 80px
        text-align left
        .content-title
          font-size 24px
          color #262626
          font-weight 500
        .content-desc
          margin 20px 0 20px 0
          font-size 14px
          color #595959
          width 280px
          line-height: 1.5;
	.body-section
    margin-left 20px
    overflow hidden
    width 300px
    .body-section-wechat
      height 82px
      color: #428077;
      background: #d8ebe4 url(https://gw.alipayobjects.com/zos/basement_prod/6cdd01ca-008e-47f9-a72e-710402ab4589.svg) 100% 100% no-repeat;
      border-radius: 4px;
      padding: 15px;
    .body-section-article
      padding 16px

</style>
